<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
    <QuickLoginView/>
    <QuickAgencyView/>
  </div>
</template>

<script>
import QuickLoginView from "@/components/quick/QuickLoginView.vue"
import QuickAgencyView from "@/components/quick/QuickAgencyView.vue"


export default {
  components: { QuickLoginView, QuickAgencyView }
}
</script>



// WEBPACK FOOTER //
// src/App.vue